import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { ICreateVoiceAgentFormData, IVoicePhoneNumber } from '@/@types/voiceAgents';

interface IAgentFormBasicTabProps {
  // LOCAL_TYPE_JUSTIFIED: single-use props interface for this tab sub-component
  form: ICreateVoiceAgentFormData;
  setField: (field: string, value: string | number | boolean | string[] | undefined) => void;
  activePhoneNumbers: IVoicePhoneNumber[];
}

export function AgentFormBasicTab({ form, setField, activePhoneNumbers }: IAgentFormBasicTabProps) {
  return (
    <div className="space-y-4 mt-4">
      <div className="space-y-2">
        <Label htmlFor="agent-name">Name</Label>
        <Input
          id="agent-name"
          value={form.name}
          onChange={e => setField('name', e.target.value)}
          placeholder="Insurance Claims Agent"
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="agent-type">Type</Label>
        <Select value={form.type} onValueChange={v => setField('type', v)}>
          <SelectTrigger id="agent-type" className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="inbound">Inbound</SelectItem>
            <SelectItem value="outbound">Outbound</SelectItem>
            <SelectItem value="both">Both</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="agent-phone">Phone Number</Label>
        <Select
          value={form.phoneNumberId ?? 'none'}
          onValueChange={v => setField('phoneNumberId', v === 'none' ? undefined : v)}
        >
          <SelectTrigger id="agent-phone" className="w-full">
            <SelectValue placeholder="No phone assigned" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">No phone assigned</SelectItem>
            {activePhoneNumbers.map(p => (
              <SelectItem key={p._id} value={p._id}>
                {p.label} ({p.phoneNumber})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="agent-prompt">System Prompt</Label>
        <Textarea
          id="agent-prompt"
          value={form.systemPrompt}
          onChange={e => setField('systemPrompt', e.target.value)}
          placeholder="You are an insurance agent assistant..."
          rows={4}
        />
      </div>
    </div>
  );
}
